import { useDispatch } from "react-redux";
import { importFromYaml } from "../../../../abstract/controller/modelYamlImport";
import * as tutorialUtils from "../../../../abstract/controller/utils/tutorialUtils";
import { setRoot } from "../../../../abstract/redux/slice/structureSlice";
import ButtonIntroWide from "../../../ui/buttons/ButtonIntroWide";
import ButtonTomatoClose from "../../../ui/buttons/ButtonTomatoClose";
import styles from "./Manual.module.scss";

const id = "dNT3";
const idNext = "dNT4";
const idPrev = "dNT2";

const next = `
functions:
  - function: Demo
    parameters:
      - parameter: Exclusion_Service
        choices:
          - choice: AllGames
          - choice: Lotto
          - choice: Joker
`;

const prev = `
functions:
  - function: Duel
`;

function ManualDedicatedNorskTipping3({ tutorial, setTutorial }) {
  if (tutorial === id) {
    return <Core setTutorial={setTutorial} />;
  }

  return null;
}

function Core({ setTutorial }) {
  const _dispatch = useDispatch();

  const handleShowMe = () => {
    const { model } = importFromYaml(next);
    _dispatch(setRoot(model, 0));
  };

  const handleBack = () => {
    const { model } = importFromYaml(prev);
    _dispatch(setRoot(model, 0));
    setTutorial(idPrev);
  };

  const handleClose = () => {
    setTutorial("null");
  };

  return (
    <>
      <div className={`${styles["foreground"]} ${styles["foreground-dnt3"]}  ${styles["overlay"]}`}>
        <ButtonTomatoClose onClick={handleClose} />
        <div className={styles["header"]}>
          <div className={styles["header__assistant"]}></div>
          <div className={styles["header__text--main"]}>
            <p>Now that we have our parameter, it’s time to populate it with choices.</p>
            <p>
              To add a choice click the <b>ADD CHOICE</b> button and then give it a name. You can
              easily add another choice once you’ve made the first one by clicking the <b>enter</b>{" "}
              button on your keyboard.
            </p>
            <p>
              Let’s add the following choices: <b>AllGames</b>, <b>Lotto</b> and <b>Joker</b>.
            </p>
          </div>
        </div>
        <div className={styles["confirmation"]}>
          <div className={styles["button"]}>
            <ButtonIntroWide theme="red" title="Go back!" onClick={handleBack} />
          </div>
          <div className={styles["button"]}>
            <ButtonIntroWide theme="tomato" title="Show me!" onClick={handleShowMe} />
          </div>
        </div>
      </div>
    </>
  );
}

export const manualValidateDedicatedNorskTipping3 = (root, tutorial, setTutorial, setMessage) => {
  if (tutorial === id) {
    let { res: resFun, msg: msgFun } = tutorialUtils.validateSingleFunction(root, "Demo");

    if (!resFun) {
      setMessage(msgFun);
      return false;
    }

    let { res: resParam, msg: msgParam } = tutorialUtils.validateChoices(
      root,
      "root→[function]→Demo→[parameter]→Exclusion_Service",
      ["AllGames", "Lotto", "Joker"],
    );

    if (!resParam) {
      setMessage(msgParam);
      return false;
    }

    setTutorial(idNext);

    setMessage("");
    return true;
  }

  return false;
};

export default ManualDedicatedNorskTipping3;
